import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Home, Search, Heart, MessageSquare, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function MobileNav() {
  const loc = useLocation();
  const nav = useNavigate();
  const { user } = useAuth();

  const items = [
    { to: "/", label: "Home", Icon: Home, id: "home" },
    { to: "/search", label: "Search", Icon: Search, id: "search" },
    { to: "/buyer", label: "Saved", Icon: Heart, id: "saved", auth: true },
    { to: "/buyer?tab=enquiries", label: "Enquiries", Icon: MessageSquare, id: "enquiries", auth: true },
    { to: user ? (user.role === "admin" ? "/admin" : user.role === "owner" ? "/owner" : "/buyer") : "/auth", label: "Profile", Icon: User, id: "profile" },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#070C1E]/95 border-t border-white/10 flex items-center justify-around py-2 md:hidden">
      {items.map(({ to, label, Icon, id, auth }) => {
        const active = loc.pathname === to.split("?")[0];
        return (
          <button key={id} data-testid={`mobilenav-${id}`}
            onClick={() => nav(auth && !user ? "/auth" : to)}
            className={`flex flex-col items-center gap-0.5 px-2 py-1 ${active ? "text-[#C5A059]" : "text-slate-400"}`}>
            <Icon className="w-5 h-5" />
            <span className="text-[10px] font-medium">{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
